import React from 'react';
import {
  Button,
  Icon,
  Popover,
  Select,
  TextField,
  Stack,
  RadioButton,
  Card,
  TextStyle
} from '@shopify/polaris';
import { SearchMinor } from '@shopify/polaris-icons';

const sortOptions = i18n => [
  {
    value: 'confidence',
    label: i18n.translate('AdminHTML.Synonym.Filter.sortMostConfidence')
  },
  {
    value: '',
    label: i18n.translate('AdminHTML.Synonym.Filter.sortMostRecent')
  },
  {
    value: 'searchTerm',
    label: i18n.translate('AdminHTML.Synonym.Filter.sortAlphabetical')
  }
];

const manualSortOptions = i18n => [
  {
    value: '',
    label: i18n.translate('AdminHTML.Synonym.Filter.sortMostRecent')
  },
  {
    value: 'searchTerm',
    label: i18n.translate('AdminHTML.Synonym.Filter.sortAlphabetical')
  }
];
const statusOption = i18n => [
  {
    value: '',
    label: i18n.translate('AdminHTML.Synonym.Filter.statusAll')
  },
  {
    value: 'enable',
    label: i18n.translate('AdminHTML.Synonym.Filter.statusEnabled')
  },
  {
    value: 'disable',
    label: i18n.translate('AdminHTML.Synonym.Filter.statusDisabled')
  }
];
const entityOption = i18n => [
  {
    value: 'TYPE',
    label: i18n.translate('AdminHTML.Synonym.Filter.entityType')
  },
  {
    value: 'COLOR',
    label: i18n.translate('AdminHTML.Synonym.Filter.entityColor')
  },
  {
    value: 'GENDER',
    label: i18n.translate('AdminHTML.Synonym.Filter.entityGender')
  },
  {
    value: 'MATERIAL',
    label: i18n.translate('AdminHTML.Synonym.Filter.entityMaterial')
  },
  {
    value: 'STYLE',
    label: i18n.translate('AdminHTML.Synonym.Filter.entityStyle')
  },
  {
    value: 'SIZE',
    label: i18n.translate('AdminHTML.Synonym.Filter.entitySize')
  }
];

const FilterPopover = ({ i18n, filter, setFilter, disabled }) => {
  const [popoverActive, setPopoverActive] = React.useState(false);
  const [localFilter, setLocalFilter] = React.useState({});
  React.useEffect(() => {
    setLocalFilter(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  const activator = (
    <Button disabled={disabled} onClick={() => setPopoverActive(!popoverActive)} disclosure>
      Filter by
    </Button>
  );
  const handleClearAll = () => {
    setLocalFilter({ status: '', entity: '' });
  };
  const handleApplyFilter = () => {
    if (localFilter.status !== filter.status || localFilter.entity !== filter.entity) {
      setFilter({ ...filter, ...localFilter });
    }
  };
  return (
    <Popover
      active={popoverActive}
      activator={activator}
      autofocusTarget="first-node"
      onClose={() => setPopoverActive(false)}>
      <Card>
        <div className="synonym-filter-popover">
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Synonym.Filter.status')}
          </TextStyle>
          <div className="radio-group">
            <Stack>
              {statusOption(i18n).map((op, index) => (
                <RadioButton
                  key={index}
                  label={op.label}
                  checked={(localFilter.status || '') === op.value}
                  id={op.value}
                  onChange={(newValue, id) =>
                    newValue && setLocalFilter({ ...localFilter, status: op.value })
                  }
                />
              ))}
            </Stack>
          </div>

          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Synonym.Filter.entity')}
          </TextStyle>
          <div className="select-entity">
            <Select
              options={entityOption(i18n)}
              placeholder={i18n.translate('AdminHTML.Synonym.Filter.entityPlaceholder')}
              onChange={value => setLocalFilter({ ...localFilter, entity: value })}
              value={localFilter.entity}
            />
          </div>

          <div className="action">
            <Button onClick={handleClearAll} plain>
              {i18n.translate('AdminHTML.Common.Action.clearAll')}
            </Button>
            <Button onClick={handleApplyFilter} primary>
              {i18n.translate('AdminHTML.Common.Action.apply')}
            </Button>
          </div>
        </div>
      </Card>
    </Popover>
  );
};
export const SynonymFilter = props => {
  const { i18n, filter, setFilter, isManual, disabled } = props;

  const [search, setSearch] = React.useState(undefined);

  let queryInterval = null;
  React.useEffect(() => {
    if (search !== undefined) {
      // eslint-disable-next-line
      queryInterval = setTimeout(() => {
        setFilter({ ...filter, search });
      }, 500);
      return () => clearTimeout(queryInterval);
    }
  }, [search]);

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '50%', marginRight: '0.5rem' }}>
        <TextField
          onChange={search => setSearch(search)}
          value={search}
          prefix={<Icon source={SearchMinor} color="base" />}
          placeholder={i18n.translate('AdminHTML.Synonym.Synonym.inputSearchText')}
          disabled={disabled}
        />
      </div>
      <div style={{ width: '30%', marginRight: '0.5rem' }}>
        <Select
          options={isManual ? manualSortOptions(i18n) : sortOptions(i18n)}
          onChange={value => setFilter({ ...filter, sort: value })}
          value={filter.sort}
          disabled={disabled}
        />
      </div>

      <div style={{ width: 'calc(20% - 30px)' }}>
        {isManual ? (
          <Select
            options={statusOption(i18n)}
            onChange={value => setFilter({ ...filter, status: value })}
            value={filter.status}
            disabled={disabled}
          />
        ) : (
          <FilterPopover
            i18n={i18n}
            filter={filter}
            setFilter={setFilter}
            isManual={isManual}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};

export default SynonymFilter;
